import { gql } from '@apollo/client';

import { FileUploadFragment } from './FileUpload.graphql';

export const SyncedRdPayrollCostFragment = gql`
  fragment SyncedRdPayrollCost on SyncedRdPayrollCost {
    id
    originalSyncDate
    provider
    fileUpload {
      ...FileUpload
    }
  }
  ${FileUploadFragment}
`;
